<template>
    <div>
        <div class="uk-padding uk-background-muted">
            <div class="uk-container">
                <h1 class="uk-heading-line uk-text-center">All Departments</h1>
            </div>
        </div>
        <div class="uk-padding">
            <div class="uk-container">
                <dl class="uk-description-list uk-description-list-divider">
                    <dt style="font-weight: bolder !important;">College of Natural & Applied Sciences, Allied Health & Nursing</dt>
                    <dd>
                        <div>
                            <ul class="uk-list uk-list-bullet">
                                <li><a href="http://nursing.ncu.edu.jm" target="_blank">School of Nursing</a></li>
                                <li><span >Department of Medical Technology</span></li>
                                <li><a href="http://cis.ncu.edu.jm" target="_blank">Department of Computer Information Science*</a></li>
                                <li><a href="http://bces.ncu.edu.jm" target="_blank">Department of Biology, Chemistry, Environmental Science*</a></li>
                                <li><span >Department of Mathematics & Engineering</span></li>
                                <li><a href="http://dnd.ncu.edu.jm" target="_blank">Department of Dietetics, Nutrition and Food Science*</a></li>
                                <li><a href="http://ddh.ncu.edu.jm" target="_blank">Department of Dental Hygiene*</a></li>
                            </ul>
                        </div>
                    </dd>
                    <dt style="font-weight: bolder !important;">College of Humanities, Behavioural & Social Sciences</dt>
                    <dd>
                        <div>
                            <ul class="uk-list uk-list-bullet">
                                <li><a href="http://dcs.ncu.edu.jm" target="_blank">Department of Communication Studies*</a></li>
                                <li><a href="http://mfa.ncu.edu.jm" target="_blank">Department of Music & Fine Arts*</a></li>
                                <li><span>Department of Social Work</span></li>
                                <li><span>Department of Criminal Justice</span></li>
                                <li><span >Department of Humanities</span></li>
                                <li><span >Department of General Studies</span></li>
                            </ul>
                        </div>
                    </dd>
                    <dt style="font-weight: bolder !important;">College of Education & Leadership</dt>
                    <dd>
                        <div>
                            <ul class="uk-list uk-list-bullet">
                                <li><a href="http://ted.ncu.edu.jm" target="_blank">Department of Teacher Education</a></li>
                                <li><a href="http://dgel.ncu.edu.jm" target="_blank">Department of Graduate Education & Leadership*</a></li>
                            </ul>
                        </div>
                    </dd>
                    <dt class="uk-text-bold" style="font-weight: bolder !important;">College of Business Management & Hospitality</dt>
                    <dd>
                        <div>
                            <ul class="uk-list uk-list-bullet">
                                <li><a href="http://bmh.ncu.edu.jm" target="_blank">Department of Business Management & Hospitality*</a></li>
                            </ul>
                        </div>
                    </dd>
                    <dt><router-link to="/college_srt" >School of Religion & Theology</router-link></dt>


                </dl>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "AllDepartments"
    }
</script>

<style scoped>
    dt{

    }
</style>